/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-05-14 14:49:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-27 16:32:42
 * @FilePath: /src/utils/price.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Currency } from '@/api/types/public';
import logger from '@/utils/client-logger';
import { accMul, add } from './tools';

export const genPrice = (priceList, currencyName) => {
  try {
    const price = priceList.find((item) => item.currency === currencyName);
    if (price) {
      if (price.sell_price && price.price !== price.sell_price) {
        price.discount = true;
      }
      return price;
    }
  } catch (error) {
    logger.error(error, priceList);
  }
  return { price: '', sell_price: '' };
};

export const priceInfo = (userInfo, product, currency) => {
  let currencyName = '';
  if (typeof currency === 'string') {
    currencyName = currency;
  } else {
    currencyName = currency?.name;
  }
  // 会员价
  if (
    userInfo?.is_member === 1 &&
    product[`price_info_v${userInfo.member_level}`] &&
    product[`discount_percent_v${userInfo.member_level}`] > 0
  ) {
    return genPrice(product[`price_info_v${userInfo.member_level}`], currencyName);
  }
  // 非会员价
  if (product?.price_info) {
    return genPrice(product.price_info, currencyName);
  }
  return {};
};

/**
 * @description: 获取单品价格（目前用于购物车列表中的数据）
 * @param {object} item 购物车列表中的每一项的数据
 * @param {Boolean} isOrigin 是否是原价 （默认false）
 * @param {string} currencyName 币种的名称
 * @return {string} 价格(保留2位小数的String)
 */
export const genItemPrice = (item, isOrigin = false, currencyName) => {
  try {
    let framePrice = 0;
    let lensPrice = 0;
    let coatingPrice = 0;
    if (item.product.price_info) {
      framePrice = isOrigin
        ? genPrice(item.product.price_info, currencyName).price
        : genPrice(item.product.price_info, currencyName).sell_price;
    }
    if (item.lens && item.lens.lens_price) {
      lensPrice = isOrigin
        ? genPrice(item.lens.lens_price, currencyName).price
        : genPrice(item.lens.lens_price, currencyName).sell_price;
    }
    if (item.coating && item.coating.price_info) {
      coatingPrice = isOrigin
        ? genPrice(item.coating.price_info, currencyName).price
        : genPrice(item.coating.price_info, currencyName).sell_price;
    }
    return accMul(add(add(framePrice, lensPrice), coatingPrice), item.qty).toFixed(2);
  } catch (error) {
    logger.log(error);
  }
  return '';
};

export const getProductDisplayLabel = (item, userInfo) => {
  let label = '';
  if (item.products_promotions_type === '3') {
    label = 'Seckill@';
  } else if (userInfo.is_member === 1 && item[`discount_percent_v${userInfo.member_level}`] > 0) {
    label = '';
  } else if (item.products_promotions_type === '2') {
    label = 'Flash Sale@';
  } else if (item.is_new_in === 1) {
    label = 'NEW IN@';
  }
  if (label) {
    return [label];
  }
  return [];
};

/**
 *
 * @param priceInfo 价格，包括售价和原价, 备注：业务计算过的价格对象
 * @param currency 币种 TODO 后续把 currency 类型规范起来
 * @param onlyPrice 是否只返回价格，不返回符号
 * @param fractionDigits 小数位数，默认为2*
 * @param {Boolean} isCompulsoryDecimal 是否强制保留两位小数
 */
export const formatPriceNumberWithSymbol = (
  price: string,
  currency: Currency | any,
  onlyPrice = false,
  fractionDigits = 2,
  isCompulsoryDecimal = true,
): string => {
  let _priceInfo = price ? `${price}` : '0.00';
  if (_priceInfo === '0.00' && !isCompulsoryDecimal) {
    _priceInfo = '0';
  }
  let _price = Number(_priceInfo.replace(/,/g, ''));
  if (isNaN(_price) || _price == null) _price = 0;
  // 格式化数字，EUR 用 de-DE，其他用 en-US
  let formattedPrice = '';

  if (currency && currency.name === 'EUR') {
    formattedPrice = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: isCompulsoryDecimal ? fractionDigits : 0,
      maximumFractionDigits: fractionDigits,
    }).format(_price);
  } else {
    formattedPrice = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: isCompulsoryDecimal ? fractionDigits : 0,
      maximumFractionDigits: fractionDigits,
    }).format(_price);
  }

  if (onlyPrice) {
    return formattedPrice;
  }
  const symbol_prefix: string = currency?.symbol_prefix || '';
  const symbol_suffix: string = currency?.symbol_suffix || '';
  const ret = `${symbol_prefix}${formattedPrice}${symbol_suffix}`;
  return ret;
};
